import { MeasureType } from '../../../../../enums'

export const TREND_MEASURES = [MeasureType.MENTIONS, MeasureType.POSTS]

export const NUMBER_MEASURES = [
  MeasureType.MENTIONS,
  MeasureType.POSTS,
  MeasureType.IMPRESSIONS,
  MeasureType.PASSION_INTENSITY,
  MeasureType.NET_SENTIMENT,
  MeasureType.UNIQUE_AUTHORS,
  MeasureType.COMMENTS,
  MeasureType.LIKES,
  MeasureType.VIEWS,
  MeasureType.SHARES,
  MeasureType.SCORE,
  MeasureType.ENGAGEMENTS,
  MeasureType.ENGAGEMENT_RATIO_ONLY
]

export const DETAIL_SUMMARY_TOPIC_COMPARISON_MEASURES = [
  MeasureType.POSTS,
  MeasureType.MENTIONS,
  MeasureType.IMPRESSIONS,
  MeasureType.PASSION_INTENSITY,
  MeasureType.NET_SENTIMENT
]

export const DETAIL_SUMMARY_AM_TOPIC_COMPARISON_MEASURES = [
  MeasureType.UNIQUE_AUTHORS,
  MeasureType.IMPRESSIONS,
  MeasureType.PASSION_INTENSITY,
  MeasureType.NET_SENTIMENT
]
